import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { FormattedMessage } from "react-intl";

import { SelectInput } from "../form";
import MessageBox from "../MessageBox";
import validationUtils from "../../../utils/ValidationUtils";

import mfaTypes from "../../dashboard/admin/users/enum/mfaTypes";
import { MFA_PREFERENCE_FORM_VALIDATION_RULES } from "./MFAPreferenceFormValidationRules";


class MFAPreferenceForm extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <div>
        <MessageBox className="alert-info">
          <FormattedMessage id="mfaPreferenceForm.mfaInfo" />
        </MessageBox>
        <form onSubmit={this.props.handleSubmit}>
          <Field
            id="mfaType"
            name="mfaType"
            groupClassName="multi-row-label"
            component={SelectInput}
            label={
              <FormattedMessage id="admin.users.form.mfa" />
            }
            options={mfaTypes}
            required={true}
          />
        </form>
      </div>
    );
  }
}

MFAPreferenceForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
};

export default connect(null, null, null, {
  withRef: true,
})(
  reduxForm({
      form: "mfaPreference",
      validate: (values) => validationUtils.validate(values, MFA_PREFERENCE_FORM_VALIDATION_RULES),
  })(MFAPreferenceForm)
);


// WEBPACK FOOTER //
// ./src/components/common/MFAPreference/MFAPreferenceForm.js